// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--2KdhN","logoTitle":"footer-module--logoTitle--2qXzO","links":"footer-module--links--3JIJ-","copyright":"footer-module--copyright--sTIJ6"};